import html2canvas from 'html2canvas';

export default {
    data () {
        return {    
            data: null,
            dataRows: [],
            timestamps: [],
            temperatures: [],            
            sensors: [],
            colors: []    
        }
    },
    methods: {
        parseTemperatures(data) {
            this.dataRows = data;

            this.data = null; 
            this.timestamps = [];

            if (!data || data.length == 0) {
                return;
            }

            this.data = {}; 
            this.data['sensor1'] = { values: [], valid: false };
            this.data['sensor2'] = { values: [], valid: false };
            this.data['sensor3'] = { values: [], valid: false };
            this.data['sensor4'] = { values: [], valid: false };

            for (var i = 0; i < data.length; i++) {
                if (data[i].length == 0) {
                    continue;
                }

                this.timestamps.push(parseInt(data[i].timestamp));

                var sensor1 = parseInt(data[i].temperature1);
                var sensor2 = parseInt(data[i].temperature2);
                var sensor3 = parseInt(data[i].temperature3);
                var sensor4 = parseInt(data[i].temperature4);

                this.data['sensor1'].values.push(sensor1);
                this.data['sensor2'].values.push(sensor2);
                this.data['sensor3'].values.push(sensor3);
                this.data['sensor4'].values.push(sensor4);
            }
        },
        calculateTemperatures() {
            this.temperatures = [];

            if (!this.dataRows || this.dataRows.length == 0) {
                return this.temperatures;
            }

            var dataRow = [this.$t('report.hours')];

            if (this.data['sensor1'].valid) {
                dataRow.push(this.$t('report.sensor-1'));
            }

            if (this.data['sensor2'].valid) {
                dataRow.push(this.$t('report.sensor-2'));
            }

            if (this.data['sensor3'].valid) {
                dataRow.push(this.$t('report.sensor-3'));
            }

            if (this.data['sensor4'].valid) {
                dataRow.push(this.$t('report.sensor-4'));
            }

            this.temperatures.push(dataRow);

            for (var j = 0; j < this.timestamps.length; j++) {
                dataRow = [new Date(this.timestamps[j])];

                if (this.data['sensor1'].valid) {
                    dataRow.push(this.data['sensor1'].values[j] / 10);
                }

                if (this.data['sensor2'].valid) {
                    dataRow.push(this.data['sensor2'].values[j] / 10);
                }

                if (this.data['sensor3'].valid) {
                    dataRow.push(this.data['sensor3'].values[j] / 10);
                }

                if (this.data['sensor4'].valid) {
                    dataRow.push(this.data['sensor4'].values[j] / 10);
                }

                this.temperatures.push(dataRow);
            }

            return this.temperatures;
        },
        checkAvailableSensors() {
            this.colors  = [];
            this.sensors = [];

            if (!this.data || this.data.length == 0) {
                return;
            }

            if (!this.data['sensor1'].values.every(x => x <= -1000)) {
                this.sensors.push({ value: 1, text: this.$t('report.sensor-1') });
                this.data['sensor1'].valid = true;
                this.colors.push('#d55f77');
            } else {
                this.data['sensor1'].valid = false;
            }
            
            if (!this.data['sensor2'].values.every(x => x <= -1000)) {
                this.sensors.push({ value: 2, text: this.$t('report.sensor-2') });
                this.data['sensor2'].valid = true;
                this.colors.push('#5da5db');
            } else {
                this.data['sensor2'].valid = false;
            }
            
            if (!this.data['sensor3'].values.every(x => x <= -1000)) {
                this.sensors.push({ value: 3, text: this.$t('report.sensor-3') });
                this.data['sensor3'].valid = true;
                this.colors.push('#ee61d9');
            } else {
                this.data['sensor3'].valid = false;
            }
            
            if (!this.data['sensor4'].values.every(x => x <= -1000)) {
                this.sensors.push({ value: 4, text: this.$t('report.sensor-4') });
                this.data['sensor4'].valid = true;
                this.colors.push('#f1e663');
            } else {
                this.data['sensor4'].valid = false;
            }          
        },
        filterAvailableSensors(sensorIds) {
            this.colors  = [];
            var dataRow = [this.$t('report.hours')];

            if (sensorIds.includes(1) && this.data['sensor1'].valid) {
                dataRow.push(this.$t('report.sensor-1'));
                this.colors.push('#d55f77');
            }

            if (sensorIds.includes(2) && this.data['sensor2'].valid) {
                dataRow.push(this.$t('report.sensor-2'));
                this.colors.push('#5da5db');
            }

            if (sensorIds.includes(3) && this.data['sensor3'].valid) {
                dataRow.push(this.$t('report.sensor-3'));
                this.colors.push('#ee61d9');
            }

            if (sensorIds.includes(4) && this.data['sensor4'].valid) {
                dataRow.push(this.$t('report.sensor-4'));
                this.colors.push('#f1e663');
            }

            var temperatures = [];

            temperatures.push(dataRow);

            for (var j = 0; j < this.timestamps.length; j++) {
                dataRow = [new Date(this.timestamps[j])];

                if (sensorIds.includes(1) && this.data['sensor1'].valid) {
                    dataRow.push(this.data['sensor1'].values[j] / 10);
                }

                if (sensorIds.includes(2) && this.data['sensor2'].valid) {
                    dataRow.push(this.data['sensor2'].values[j] / 10);
                }

                if (sensorIds.includes(3) && this.data['sensor3'].valid) {
                    dataRow.push(this.data['sensor3'].values[j] / 10);
                }

                if (sensorIds.includes(4) && this.data['sensor4'].valid) {
                    dataRow.push(this.data['sensor4'].values[j] / 10);
                }

                temperatures.push(dataRow);
            }

            return temperatures;
        },
        calculateLastHoursTimestamps(timestamp, hours) {
            timestamp.end = new Date().getTime();
            timestamp.init = timestamp.end - (hours * 3600 * 1000);
        },
        isTimestampsHigherThan24h(timestamp) {
						const oneDay = 1000 * 60 * 60 * 24;
							
						const diff = timestamp.end - timestamp.init;

						if (diff > oneDay) {
							return true;
						}
						
						return false;
        },
        isTimestampsHigherThan3days(timestamp) {
						const thirtyDays = 1000 * 60 * 60 * 24 * 3;
							
						const diff = timestamp.end - timestamp.init;
						
						if (diff > thirtyDays) {
							return true;
						}
						
						return false;
        },
        isTimestampsHigherThan9days(timestamp) {
						const thirtyDays = 1000 * 60 * 60 * 24 * 9;
							
						const diff = timestamp.end - timestamp.init;
						
						if (diff > thirtyDays) {
							return true;
						}
						
						return false;
        },
        isTimestampsHigherThan30days(timestamp) {
						const thirtyDays = 1000 * 60 * 60 * 24 * 30;
							
						const diff = timestamp.end - timestamp.init;
						
						if (diff > thirtyDays) {
							return true;
						}
						
						return false;
        },
        /*exportChartAsCSV() {
            var csvFile = 'timestamp;fractal;temperature1;temperature2;temperature3;temperature4\r\n';

            if (!this.dataRows || this.dataRows.length == 0) {
                return csvFile;
            }

            for (var i = 0; i < this.dataRows.length; i++) {
                if (this.dataRows[i].length == 0) {
                    continue;
                }

                var dataRow = '';
                
                dataRow += this.dataRows[i].timestamp + ';';
                dataRow += this.dataRows[i].fractal + ';';
                dataRow += this.dataRows[i].temperature1 + ';';
                dataRow += this.dataRows[i].temperature2 + ';';
                dataRow += this.dataRows[i].temperature3 + ';';
                dataRow += this.dataRows[i].temperature4 + '\r\n';

                csvFile += dataRow;
            }

            return csvFile;
        },*/
        getCsvAsBase64Attachment(csvFile) {
            return 'base64:data.csv//' + btoa(csvFile);
        },
        getPdfAsBase64Attachment(pdfFile, callback) {
						var reader = new FileReader();
						reader.onload = function () {
								if (callback)	{
										var result = reader.result;
										result = result.substring(result.indexOf(';base64,') + ';base64,'.length);
										result = 'base64:report.pdf//' + result;
										callback(result);
								}
						};
						reader.readAsDataURL(pdfFile);
        },
        takeChartScreenshot(titleElement, graphElement, callback) {
           html2canvas(titleElement).then(titleCanvas => {
                html2canvas(graphElement).then(graphCanvas => {
                    let offset = 40;
                    let mergeCanvas = document.createElement('canvas');
                    let mergeCanvasContext = mergeCanvas.getContext('2d');
                    mergeCanvas.width  = graphCanvas.width;
                    mergeCanvas.height = graphCanvas.height+offset;

										mergeCanvasContext.fillStyle = "#FFF";
										
                    mergeCanvasContext.drawImage(graphCanvas, 0, 0, graphCanvas.width, graphCanvas.height, 0, offset, graphCanvas.width, graphCanvas.height);

                    mergeCanvasContext.fillRect(0, 0, graphCanvas.width, titleCanvas.height);
                    
										mergeCanvasContext.drawImage(titleCanvas, 0, 0, titleCanvas.width, titleCanvas.height, (graphCanvas.width-titleCanvas.width)/2, 0, titleCanvas.width, titleCanvas.height);

                    var image = mergeCanvas.toDataURL();

                    if (callback) callback(image.replace('data:image/png;base64,','base64:graph.png//'));
                });
            });
        }
    }
}